import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as _ from 'lodash';
import { Button, Modal, Input } from 'semantic-ui-react';
import CustomDropdown from '../../../../common/CustomDropdown';
import { closeIconSvg } from '../../../../../HelperMethods/constants';
import { APPROVAL_OPTIONS, APPROVAL_OPTIONS_KEYED } from '../../../../../HelperMethods/enums';
import { upsertComment } from '../../../../../actions/commentActions';
import { updateApprovalMatrixInfoOfATask } from '../../redux/actions';
import { APPROVAL_ACTION_MESSAGE } from '../lib/constants';

const APPROVAL_OPTIONS_BY_STATUS = _.keyBy(Object.values(APPROVAL_OPTIONS), 'status');

function ApprovalActionPopup({ open, handleToggle, dataForPopup = {}, formik, task, handleApprovalStatus }) {
  const { data: { value = '' } = {}, matrixIndex, approverIndex, statusForApprovalLimit } = dataForPopup;
  const [approvalStatus, setApprovalStatus] = useState(APPROVAL_OPTIONS_BY_STATUS[value].key);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const handleChange = ({ status }) => {
    setComment('');
    setApprovalStatus(status);
  };

  const handleComment = (event) => {
    setComment(event.target.value);
  };

  const handleError = () => {
    if (approvalStatus !== 'approve' && !comment) {
      return 'Comment is required';
    }
    return '';
  };

  const handleSubmit = async () => {
    const { fieldId, id } = task;
    const approval = _.cloneDeep(_.get(formik, 'values.approval_matrixInfo', []));
    const err = handleError();
    const originalApprovalStatus = APPROVAL_OPTIONS_KEYED[approvalStatus].status;
    setError(err);
    if (!err) {
      const matrix = approval[matrixIndex];
      const approver = matrix.approvers[approverIndex];
      approver.approvalStatus = originalApprovalStatus;
      approver.comment = comment;
      const newComment = APPROVAL_ACTION_MESSAGE[approvalStatus](matrix.displayName, approver.approverLimit, comment);
      await dispatch(upsertComment({ comment: newComment, fieldId, taskId: id, autoGenerated: true }));

      try {
        handleToggle();
        const data = {
          taskId: id,
          approvalStatus: originalApprovalStatus,
          approvalMatrixId: matrix.id,
          approvalLimit: approver.approverLimit,
          comment,
        };
        const updatedTask = await dispatch(updateApprovalMatrixInfoOfATask(data));
        formik.setFieldValue('approval_matrixInfo', approval, false);
        handleApprovalStatus(updatedTask.approvalStatus);
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <Modal size="tiny" open={open}>
      <div>
        <h3 style={{ padding: '10px', height: '50px', background: 'rgba(200, 244, 240, 0.5)' }}>
          Update Approval Status
        </h3>
        <div style={{ position: 'absolute', top: '10px', right: '12px', zIndex: '2' }}>
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
            onClick={() => {
              handleToggle();
            }}
            style={{ cursor: 'pointer' }}
            alt="Close Icon"
          />
        </div>
      </div>
      <div style={{ margin: '20px' }}>
        <div style={{ margin: '10px 0' }}>
          <label>Approval Status</label>
        </div>
        <CustomDropdown
          placeholder="Action"
          search
          selection
          name="action"
          value={approvalStatus}
          options={Object.values(APPROVAL_OPTIONS)
            .filter((option) => option.status !== statusForApprovalLimit)
            .map((option) => {
              return {
                key: option.key,
                value: option.key,
                text: option.label,
              };
            })}
          onChange={(event, data) => {
            handleChange({ event, status: data.value });
          }}
        />
        <br />
        {approvalStatus !== APPROVAL_OPTIONS.APPROVE.key && (
          <>
            <div style={{ margin: '10px 0' }}>
              <label>Comment*</label>
            </div>
            <Input
              placeholder="Tell us more"
              value={comment}
              onChange={(event) => {
                handleComment(event);
              }}
              style={{ width: '450px' }}
            />
            {error && <div className="errorText">*{error}</div>}
          </>
        )}
      </div>

      <div style={{ padding: '10px', float: 'right' }}>
        <Button basic onClick={handleToggle}>
          Cancel
        </Button>
        <Button secondary onClick={handleSubmit}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
}

export default ApprovalActionPopup;
